<template>
    <div component="ProjectActorDialogBody">
        <div class="tabs">
            <btn
                :text="'Portfolio'"
                radius="mediumBottom"
                istab="true"
                size="small"
                :icon="'volume_up'"
                :color="getTabColor('portfolio')"
                @click="setSection('portfolio')"
            />
            <btn
                :text="'Winlist'"
                radius="mediumBottom"
                istab="true"
                size="small"
                :icon="'military_tech'"
                :color="getTabColor('win')"
                @click="setSection('win')"
            />
            <btn
                :text="'Shortlist'"
                radius="mediumBottom"
                istab="true"
                size="small"
                :icon="'playlist_add_check'"
                :color="getTabColor('short')"
                @click="setSection('short')"
            />
        </div>
        <div class="holder">
            <div class="wrapper" ref="wrapper">
                <project-actor-dialog-info class="section" :actor="actor" />
                <project-actor-dialog-winlist class="section" :actor="actor" />
                <project-actor-dialog-shrotlist class="section" :actor="actor" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import ProjectActorDialogInfo from './ProjectActorDialogInfo';
import ProjectActorDialogWinlist from '@/components/Project/Dialogs/ProjectActorDialog/ProjectActorDialogWinlist';
import ProjectActorDialogShrotlist from '@/components/Project/Dialogs/ProjectActorDialog/ProjectActorDialogShortlist';

export default {
    name: 'ProjectActorDialogBody',

    components: { ProjectActorDialogShrotlist, ProjectActorDialogWinlist, ProjectActorDialogInfo },

    props: {
        actor: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            selected: 'portfolio',
        };
    },

    methods: {
        ...mapActions([]),

        getTabColor(tab) {
            return this.selected === tab ? 'white' : 'ghostLight';
        },

        setSection(tab) {
            this.selected = tab;
            let left = '0%';

            switch (tab) {
                case 'win':
                    left = '-33.33%';
                    break;
                case 'short':
                    left = '-66.66%';
                    break;
                default:
                    break;
            }

            this.$refs.wrapper.style.transform = 'translateX(' + left + ')';
        },
    },

    computed: {
        ...mapGetters([]),

        rating() {
            return this.actor?.rating ?? {};
        },
    },
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectActorDialogBody'] {
    background: linear-gradient(to bottom, #eee, #fff);
    width: calc(100% - 500px);
    .flex-column;
    align-items: flex-start;
    overflow: hidden;
    z-index: 5;

    .holder {
        position: relative;
        width: 100%;
        height: 100%;
        display: flex;

        .wrapper {
            display: flex;
            position: absolute;
            width: 300%;
            height: 100%;
            transition: 0.5s;

            .section {
                width: 33.33%;
            }
        }
    }

    .tabs {
        width: 100%;
        padding-left: 25px;
        border-top: 1px solid @grey_dk;

        button:not(.v-btn):not(.v-icon)[istab='true'] {
            margin-top: -1px;
            border: 1px solid @grey_dk;

            &[color='white'] {
                pointer-events: none;
            }
        }
    }
}
</style>
